export const COLOR = {
  primary: {
    'primary-1': '#FFF4E3',
    'primary-2': '#FFE9C7',
    'primary-3': '#FFD59E',
    'primary-4': '#FFBF75',
    'primary-5': '#FFA64D',
    'primary-6': '#FD8A24',
    'primary-7': '#D66813',
    'primary-8': '#B04B07',
    'primary-9': '#8A3200',
    'primary-10': '#632100',
  },
  neutral: {
    'neutral-1': '#FFFDF7',
    'neutral-2': '#FAF9F5',
    'neutral-3': '#F5F4F2',
    'neutral-4': '#F0EFEE',
    'neutral-3-1': '#F5F5F5',
  },
  purpel: {
    'purpel-1': '#F0F3FF',
    'purpel-2': '#E8ECFF',
    'purpel-3': '#B6BEF2',
    'purpel-4': '#8791E6',
    'purpel-5': '#5D65D9',
    'purpel-6': '#383ECD',
    'purpel-7': '#531DAB',
    'purpel-8': '#391085',
    'purpel-9': '#22075E',
    'purpel-10': '#120338',
  },
  neutralTrans: {
    'neutralTrans-3': '#00000008',
    'neutralTrans-25': '#00000040',
    'neutralTrans-15': '#00000026',
  },
  surfaceNeutralBold: {
    'neutral-11': '#222222',
  },
  green: {
    'green-1': '#EDFCDE',
    'green-4': '#95DE64',
    'green-7': '#389E0D',
  },
  linen: '#f7f1e6',
};

export const COLOR_CONFIG = {
  red: '#FF4D4F',
  'neutral-text': '#808080',
  magenta: '#EB2F96',
  cyan: '#08979C',
  doctor: '#f9f9f9',
  white: '#fff',
  'crystal-cut': '#f7f4ed',
  'white-smoke': '#f5f5f5',
  'black-out': '#2222221a',
  'dwarven-bronze': '#0000000f',
  'cyan-suble': '#5CDBD3',
  'cyan-subtle': '#E6FFFB',
  'magenta-suble': '#FFADD2',
  'magenta-subtle': '#FFF0F6',
};
